import { ImageCategory, ImageAsset } from '../services/imageAssetsService';
import { getPublicAssetUrl } from './storageConfig';

// Generate Azure blob URL with SAS token using runtime environment detection
function getAzureBlobUrl(assetPath: string): string {
  const rel = assetPath.replace(/^public-assets\//i, '');
  return getPublicAssetUrl(rel);
}

// Generate display name from filename
function generateDisplayName(filename: string): string {
  const nameWithoutExtension = filename.split('.').slice(0, -1).join('.');
  return nameWithoutExtension
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}

// Real image assets from Azure blob storage
export const actualImageAssets: ImageCategory[] = [
  {
    name: 'hardware',
    displayName: 'Hardware',
    subcategories: [
      {
        name: 'apple',
        displayName: 'Apple',
        assets: [
          {
            filename: 'ipad_a16.png',
            displayName: generateDisplayName('ipad_a16.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/ipad_a16.png'),
            description: 'iPad with A16 chip'
          },
          {
            filename: 'ipad_air_11_inch_m3.png',
            displayName: generateDisplayName('ipad_air_11_inch_m3.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/ipad_air_11_inch_m3.png'),
            description: 'iPad Air 11-inch with M3 chip'
          },
          {
            filename: 'ipad_air_13_inch_m3.png',
            displayName: generateDisplayName('ipad_air_13_inch_m3.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/ipad_air_13_inch_m3.png'),
            description: 'iPad Air 13-inch with M3 chip'
          },
          {
            filename: 'ipad_mini_a17_pro.png',
            displayName: generateDisplayName('ipad_mini_a17_pro.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/ipad_mini_a17_pro.png'),
            description: 'iPad Mini with A17 Pro chip'
          },
          {
            filename: 'ipad_pro_11_inch_m4.png',
            displayName: generateDisplayName('ipad_pro_11_inch_m4.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/ipad_pro_11_inch_m4.png'),
            description: 'iPad Pro 11-inch with M4 chip'
          },
          {
            filename: 'ipad_pro_13_inch_m4.png',
            displayName: generateDisplayName('ipad_pro_13_inch_m4.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/ipad_pro_13_inch_m4.png'),
            description: 'iPad Pro 13-inch with M4 chip'
          },
          {
            filename: 'iphone_15_pro.png',
            displayName: generateDisplayName('iphone_15_pro.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_15_pro.png'),
            description: 'iPhone 15 Pro'
          },
          {
            filename: 'iphone_15_pro_max.png',
            displayName: generateDisplayName('iphone_15_pro_max.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_15_pro_max.png'),
            description: 'iPhone 15 Pro Max'
          },
          {
            filename: 'iphone_16.png',
            displayName: generateDisplayName('iphone_16.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_16.png'),
            description: 'iPhone 16'
          },
          {
            filename: 'iphone_16_plus.png',
            displayName: generateDisplayName('iphone_16_plus.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_16_plus.png'),
            description: 'iPhone 16 Plus'
          },
          {
            filename: 'iphone_16_pro.png',
            displayName: generateDisplayName('iphone_16_pro.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_16_pro.png'),
            description: 'iPhone 16 Pro'
          },
          {
            filename: 'iphone_16_pro_max.png',
            displayName: generateDisplayName('iphone_16_pro_max.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_16_pro_max.png'),
            description: 'iPhone 16 Pro Max'
          },
          {
            filename: 'iphone_16e.png',
            displayName: generateDisplayName('iphone_16e.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_16e.png'),
            description: 'iPhone 16E'
          },
          {
            filename: 'iphone_17.png',
            displayName: generateDisplayName('iphone_17.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_17.png'),
            description: 'iPhone 17'
          },
          {
            filename: 'iphone_17_pro.png',
            displayName: generateDisplayName('iphone_17_pro.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_17_pro.png'),
            description: 'iPhone 17 Pro'
          },
          {
            filename: 'iphone_17_pro_max.png',
            displayName: generateDisplayName('iphone_17_pro_max.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_17_pro_max.png'),
            description: 'iPhone 17 Pro Max'
          },
          {
            filename: 'iphone_air.png',
            displayName: generateDisplayName('iphone_air.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_air.png'),
            description: 'iPhone Air'
          },
          {
            filename: 'iphone_se_3rd_gen.png',
            displayName: generateDisplayName('iphone_se_3rd_gen.png'),
            category: 'hardware',
            subcategory: 'apple',
            url: getAzureBlobUrl('hardware/apple/iphone_se_3rd_gen.png'),
            description: 'iPhone SE 3rd Generation'
          }
        ]
      },
      {
        name: 'google',
        displayName: 'Google',
        assets: [
          {
            filename: 'pixel_10.png',
            displayName: generateDisplayName('pixel_10.png'),
            category: 'hardware',
            subcategory: 'google',
            url: getAzureBlobUrl('hardware/google/pixel_10.png'),
            description: 'Google Pixel 10'
          },
          {
            filename: 'pixel_10_pro.png',
            displayName: generateDisplayName('pixel_10_pro.png'),
            category: 'hardware',
            subcategory: 'google',
            url: getAzureBlobUrl('hardware/google/pixel_10_pro.png'),
            description: 'Google Pixel 10 Pro'
          },
          {
            filename: 'pixel_10_pro_xl.png',
            displayName: generateDisplayName('pixel_10_pro_xl.png'),
            category: 'hardware',
            subcategory: 'google',
            url: getAzureBlobUrl('hardware/google/pixel_10_pro_xl.png'),
            description: 'Google Pixel 10 Pro XL'
          }
        ]
      },
      {
        name: 'samsung',
        displayName: 'Samsung',
        assets: [
          {
            filename: 'galaxy_a36.png',
            displayName: generateDisplayName('galaxy_a36.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_a36.png'),
            description: 'Samsung Galaxy A36'
          },
          {
            filename: 'galaxy_a56.png',
            displayName: generateDisplayName('galaxy_a56.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_a56.png'),
            description: 'Samsung Galaxy A56'
          },
          {
            filename: 'galaxy_s24_ultra.png',
            displayName: generateDisplayName('galaxy_s24_ultra.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_s24_ultra.png'),
            description: 'Samsung Galaxy S24 Ultra'
          },
          {
            filename: 'galaxy_s25+.png',
            displayName: generateDisplayName('galaxy_s25+.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_s25+.png'),
            description: 'Samsung Galaxy S25+'
          },
          {
            filename: 'galaxy_s25.png',
            displayName: generateDisplayName('galaxy_s25.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_s25.png'),
            description: 'Samsung Galaxy S25'
          },
          {
            filename: 'galaxy_s25_edge.png',
            displayName: generateDisplayName('galaxy_s25_edge.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_s25_edge.png'),
            description: 'Samsung Galaxy S25 Edge'
          },
          {
            filename: 'galaxy_s25_ultra.png',
            displayName: generateDisplayName('galaxy_s25_ultra.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_s25_ultra.png'),
            description: 'Samsung Galaxy S25 Ultra'
          },
          {
            filename: 'galaxy_xcover7_pro.png',
            displayName: generateDisplayName('galaxy_xcover7_pro.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_xcover7_pro.png'),
            description: 'Samsung Galaxy XCover 7 Pro - Rugged smartphone'
          },
          {
            filename: 'galaxy_z_flip7.png',
            displayName: generateDisplayName('galaxy_z_flip7.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_z_flip7.png'),
            description: 'Samsung Galaxy Z Flip 7'
          },
          {
            filename: 'galaxy_z_fold7.png',
            displayName: generateDisplayName('galaxy_z_fold7.png'),
            category: 'hardware',
            subcategory: 'samsung',
            url: getAzureBlobUrl('hardware/samsung/galaxy_z_fold7.png'),
            description: 'Samsung Galaxy Z Fold 7'
          }
        ]
      },
      {
        name: 'telstra',
        displayName: 'Telstra',
        assets: [
          {
            filename: 'netgear_nighthawk_m6.png',
            displayName: generateDisplayName('netgear_nighthawk_m6.png'),
            category: 'hardware',
            subcategory: 'telstra',
            url: getAzureBlobUrl('hardware/telstra/netgear_nighthawk_m6.png'),
            description: 'Netgear Nighthawk M6 5G Mobile Hotspot'
          },
          {
            filename: 'netgear_nighthawk_m7_ultra.png',
            displayName: generateDisplayName('netgear_nighthawk_m7_ultra.png'),
            category: 'hardware',
            subcategory: 'telstra',
            url: getAzureBlobUrl('hardware/telstra/netgear_nighthawk_m7_ultra.png'),
            description: 'Netgear Nighthawk M7 Ultra 5G Mobile Hotspot'
          },
          {
            filename: 'sonim_h700_wifi_hotspot.png',
            displayName: generateDisplayName('sonim_h700_wifi_hotspot.png'),
            category: 'hardware',
            subcategory: 'telstra',
            url: getAzureBlobUrl('hardware/telstra/sonim_h700_wifi_hotspot.png'),
            description: 'Sonim H700 WiFi Hotspot for Telstra'
          },
          {
            filename: 'telsta_5g_wifi_hotspot.png', // Note: typo in original filename
            displayName: generateDisplayName('telsta_5g_wifi_hotspot.png'),
            category: 'hardware',
            subcategory: 'telstra',
            url: getAzureBlobUrl('hardware/telstra/telsta_5g_wifi_hotspot.png'),
            description: 'Telstra 5G WiFi Hotspot'
          },
          {
            filename: 'telstra_5g_hotspot.png',
            displayName: generateDisplayName('telstra_5g_hotspot.png'),
            category: 'hardware',
            subcategory: 'telstra',
            url: getAzureBlobUrl('hardware/telstra/telstra_5g_hotspot.png'),
            description: 'Telstra 5G Mobile Hotspot'
          }
        ]
      }
    ]
  },
  {
    name: 'software',
    displayName: 'Software',
    subcategories: [
      {
        name: 'microsoft',
        displayName: 'Microsoft',
        assets: [
          {
            filename: 'microsoft/azure.png',
            displayName: 'Microsoft Azure',
            category: 'software',
            subcategory: 'microsoft',
            url: getAzureBlobUrl('software/microsoft/azure.png'),
            description: 'Microsoft Azure'
          },
          {
            filename: 'microsoft/m365.png',
            displayName: 'Microsoft 365',
            category: 'software',
            subcategory: 'microsoft',
            url: getAzureBlobUrl('software/microsoft/m365.png'),
            description: 'Microsoft 365'
          },
          {
            filename: 'microsoft/teams.png',
            displayName: 'Microsoft Teams',
            category: 'software',
            subcategory: 'microsoft',
            url: getAzureBlobUrl('software/microsoft/teams.png'),
            description: 'Microsoft Teams'
          },
          {
            filename: 'microsoft/sharepoint.png',
            displayName: 'Microsoft SharePoint',
            category: 'software',
            subcategory: 'microsoft',
            url: getAzureBlobUrl('software/microsoft/sharepoint.png'),
            description: 'Microsoft SharePoint'
          },
          {
            filename: 'microsoft/defender.png',
            displayName: 'Microsoft Defender',
            category: 'software',
            subcategory: 'microsoft',
            url: getAzureBlobUrl('software/microsoft/defender.png'),
            description: 'Microsoft Defender'
          },
          {
            filename: 'microsoft/intune.png',
            displayName: 'Microsoft Intune',
            category: 'software',
            subcategory: 'microsoft',
            url: getAzureBlobUrl('software/microsoft/intune.png'),
            description: 'Microsoft Intune'
          }
        ]
      }
    ]
  },
  {
    name: 'generic',
    displayName: 'Generic Icons',
    subcategories: [
      {
        name: 'icons',
        displayName: 'Generic Icons',
        assets: [
          {
            filename: '5g.png',
            displayName: '5G',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/5g.png'),
            description: '5G Technology'
          },
          {
            filename: 'Artificial intelligence.png',
            displayName: 'Artificial Intelligence',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Artificial intelligence.png'),
            description: 'Artificial Intelligence'
          },
          {
            filename: 'Automation.png',
            displayName: 'Automation',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Automation.png'),
            description: 'Automation Technology'
          },
          {
            filename: 'Cloud computing.png',
            displayName: 'Cloud Computing',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Cloud computing.png'),
            description: 'Cloud Computing'
          },
          {
            filename: 'Machine learning.png',
            displayName: 'Machine Learning',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Machine learning.png'),
            description: 'Machine Learning'
          },
          {
            filename: 'Blockchain.png',
            displayName: 'Blockchain',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Blockchain.png'),
            description: 'Blockchain Technology'
          },
          {
            filename: 'Robotics.png',
            displayName: 'Robotics',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Robotics.png'),
            description: 'Robotics'
          },
          {
            filename: 'Smart home.png',
            displayName: 'Smart Home',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Smart home.png'),
            description: 'Smart Home Technology'
          },
          {
            filename: 'Technology.png',
            displayName: 'Technology',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Technology.png'),
            description: 'General Technology'
          },
          {
            filename: 'Virtual reality.png',
            displayName: 'Virtual Reality',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Virtual reality.png'),
            description: 'Virtual Reality'
          },
          {
            filename: 'Innovation.png',
            displayName: 'Innovation',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Innovation.png'),
            description: 'Innovation'
          },
          {
            filename: 'Quantum computing.png',
            displayName: 'Quantum Computing',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/Quantum computing.png'),
            description: 'Quantum Computing'
          },
          {
            filename: 'settings-3_hires.png',
            displayName: 'Settings',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/settings-3_hires.png'),
            description: 'Settings and Configuration'
          },
          {
            filename: 'engineering_hires.png',
            displayName: 'Engineering',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/engineering_hires.png'),
            description: 'Engineering Services'
          },
          {
            filename: 'automatic_hires.png',
            displayName: 'Automatic',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/automatic_hires.png'),
            description: 'Automated Systems'
          },
          {
            filename: 'hologram_hires.png',
            displayName: 'Hologram',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/hologram_hires.png'),
            description: 'Holographic Technology'
          },
          {
            filename: 'robot_hires.png',
            displayName: 'Robot',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/robot_hires.png'),
            description: 'Robotic Solutions'
          },
          {
            filename: 'signal.png',
            displayName: 'Signal',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/signal.png'),
            description: 'Signal Technology'
          },
          {
            filename: 'sharing.png',
            displayName: 'Sharing',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/sharing.png'),
            description: 'Data Sharing'
          },
          {
            filename: 'storage.png',
            displayName: 'Storage',
            category: 'generic',
            subcategory: 'icons',
            url: getAzureBlobUrl('generic/storage.png'),
            description: 'Data Storage'
          }
        ]
      }
    ]
  }
];

// Search function for actual assets
export function searchActualAssets(query: string, category?: string): ImageAsset[] {
  const search = query.toLowerCase();
  let allAssets: ImageAsset[] = [];

  // Collect all assets
  for (const cat of actualImageAssets) {
    if (category && cat.name !== category) continue;
    
    for (const subcat of cat.subcategories) {
      allAssets = [...allAssets, ...subcat.assets];
    }
  }

  // Filter by search term
  return allAssets.filter(asset => 
    asset.displayName.toLowerCase().includes(search) ||
    asset.filename.toLowerCase().includes(search) ||
    asset.description?.toLowerCase().includes(search)
  );
}
